import {
  Conversation,
  ConversationUpdateReason,
  Message,
  MessageUpdateReason,
  Participant,
  ParticipantUpdateReason,
  User,
  UserUpdateReason,
} from '@twilio/conversations';

import { ChatChannelType } from '../../interfaces/chat-model.interface';

export const TWILIO_AUTO_CONVERSATION_TITLE = '<auto>';

export interface TwilioUserUpdated {
  user: User;
  updateReasons: UserUpdateReason[];
}

export interface TwilioMessageUpdated {
  message: Message;
  updateReasons: MessageUpdateReason[];
}

export interface TwilioParticipantUpdated {
  participant: Participant;
  updateReasons: ParticipantUpdateReason[];
}

export interface TwilioConversationUpdated {
  conversation: Conversation;
  updateReasons: ConversationUpdateReason[];
}

export interface TwilioMessageAttributes extends Record<string, unknown> {
  hidden?: string[];
}

export interface TwilioUserAttributes extends Record<string, unknown> {
  image_url?: string;
  muted?: string[];
  blocked?: string[];
  deleted?: boolean;
  deactivated?: boolean;
}

export interface TwilioConversationAttributes extends Record<string, unknown> {
  type?: ChatChannelType;
  channel_id?: string;
}

export interface TwilioError {
  stack: string;
  message: string;
  status?: number;
}
